// Výchozí textový obsah webu.
// Použije se, dokud není odpovídající klíč vyplněný v tabulce web_settings.
// Jakmile se hodnota do web_settings doplní (přes Supabase nebo budoucí
// administraci), přebije zdejší default.

const ABOUT_TEXT = [
    'Úplné počátky této kapely se datují k podzimu roku 1970. Ale takřka 25 let první historie je na opravdu nekonečné povídání. Historie současné sestavy, kterou můžete slyšet na zábavách, se odvíjí od roku 1995.',
    'V kapele hráli muzikanti Josef Ryšávka, František Kratochvíl, Jan Tůma, Dušan Bílek, Pavel Anděl, Michal Ryšávka, David Vonda. Později v kapele hráli Ivan Brož a Hanka Brejchová, Míša Balvínová, Standa Peschik, Milan Valenta, Lukáš Turek, Josef Hauer, Zdeněk Mráček, Lucka Kratochvílová, Lucie Márová.',
    'Od roku 2008 hraje kapela ve složení: Michal Ryšávka, Edita Bartovská, Jirka Rádl, Josef Ryšávka a Zdeněk Mráček. V roce 2014 odešel po krásné sedmileté etapě Jirka Rádl, na rok za piano usedl Rudla Kotlár a v roce 2015 vyšla v naší kapele nová hvězda se saxofonem v ruce: Matouš Hejduk. Po náhlém odchodu Zdeňka Mráčka má kapela od léta 2016 opět plné složení, saxofon a zpěv Nikol Straková.',
    'Léta běží, čas plyne tak rychle… a během jara 2023 Nikol přesunula své angažmá do většího města a větší kapely. O rok později se Editě plní očekávané mateřství a po létech strávených v tomto nočním hudebním kolotoči odchází se plně věnovat svému potomkovi. Přesněji řečeno to bylo 16 poctivě odzpívaných let!! Děkujeme!!!',
    'Mikrofonu se chytí Martina Bohatá. Netrvá to dlouho a vytoužené těhotenství trefí i Martinu. Hříčka osudu do kapely vrátí Míšu Balvínovou, která se mezitím vdala, rozvedla, vdala a nyní je z ní nadobro Míša Valentová. Příjmení se velmi podobá příjmení od našeho bývalého kytaristy Milana Valenty. No a jedeme dál, píše se rok {ROK}.'
].join('\n\n');

const RIDER_TEXT = [
    'Kapela má k dispozici vlastní ozvučovací aparaturu o celkovém zvukovém výkonu 7 kW a světelném 16 kW.',
    [
        'P.A.: Adamson CS10p (point source), CS119 (subwoofery)',
        'Platforma: UAD Apollo x6 + Yamaha UR824',
        'Mix: YAMAHA 01V96 + převodník 8CH AD/DA',
        'Monitory: RCF 310 aktiv, DBAudiotechnologies FMX aktiv',
        'Mikrofony: Shure, AKG, Sennheiser',
        'Bezdrátová sada: Sennheiser',
        'LED + PAR 64',
        'Light pult',
        'Kabely a konektory: Sumit'
    ].join('\n')
].join('\n\n');

export const SETTING_DEFAULTS = {
    band_name: 'Amati Band',
    hero_photo: '',
    intro_text: 'Hudební skupina hrající tzv. střední proud na tanečních zábavách, ' +
        'maturitních plesech a firemních večírcích. Hrajeme známé písničky interpretů ' +
        'na české hudební scéně jako např. Olympic, Kabát, Katapult, Turbo, Zich, Brutus, ' +
        'Vondráčková, Zagorová, ABBA, Schelinger, Chinaski, Ready Kirken, M. David a mnoho dalších.',
    about_text: ABOUT_TEXT,
    references_intro: 'Již jsme hráli na spoustě míst, zde jsou některá z nich:',
    references_places: 'KD Stříbro, Beseda Stříbro, Klatovy, Staňkov, Holýšov, Šťáhlavice, ' +
        'Nýřany, Kšice, Alfa Plzeň, Peklo Plzeň, Beseda Plzeň, Park hotel v Plzni, ' +
        'letní slavnosti Sytno, Hořehledy, Borovno, Chrást, Vranov, Cebiv, Hněvnice, ' +
        'hotely v Mariánských Lázních, Mže Tachov, taneční kurzy ve Staňkově, Holýšově ' +
        'a Tachově, EMZ Hanauer Černošín, Mochov, Bělá nad Radbuzou a další…',
    contact_name: 'Michal Ryšávka',
    contact_phone: '736 778 765',
    contact_email: 'MichalRysavka@seznam.cz',
    facebook_url: '',
    instagram_url: '',
    youtube_url: '',
    rider_text: RIDER_TEXT,
    tech_requirements: 'elektřina 400V 3x16A, nouzově 230V min. 1x16A\nzastřešené pódium',
    sound_connection: 'Hraje-li na akci více kapel se společným zvukařem, ' +
        'předáváme zvukový signál přes split (rozbočovač), který zvukař ' +
        'zapojí do svého mixu na FOH. Rozpis výstupů našeho splitu:',
    sound_notes: 'Splitter je umístěn na pravé straně při pohledu do publika.' +
        '\n\n' +
        'Mixáž monitorů si kapela dělá na pódiu ještě před splitterem, do dvou ' +
        'výstupů — Monitor 1 a Monitor 2. Monitor 1 má dva boxy v přední linii ' +
        'zapojené v sérii za sebou (střed a levá strana při pohledu do publika), ' +
        'Monitor 2 je na pravé straně při pohledu do publika. Sběr signálů ' +
        'nástrojů do splitteru si kapela řeší vlastním vybavením.'
};

// Rozpis výstupů ze splitu — sekce „Pro pořadatele".
export const SOUND_CHANNELS = [
    { ch: '1',  signal: 'Voc.Michal',           output: 'Out1',  connector: 'XLR MALE' },
    { ch: '2',  signal: 'Voc.Míša',             output: 'Out2',  connector: 'XLR MALE' },
    { ch: '3',  signal: 'Voc.Matouš',           output: 'Out3',  connector: 'XLR MALE' },
    { ch: '4',  signal: 'Voc.Josef',            output: 'Out4',  connector: 'XLR MALE' },
    { ch: '7',  signal: 'FX L',                 output: 'Mon L', connector: 'XLR MALE' },
    { ch: '8',  signal: 'FX R',                 output: 'Mon R', connector: 'XLR MALE' },
    { ch: '9',  signal: 'Trumpeta',             output: 'AD1',   connector: 'TRS FEMALE' },
    { ch: '10', signal: 'Tenor sax',            output: 'AD2',   connector: 'TRS FEMALE' },
    { ch: '11', signal: 'Basa',                 output: 'AD3',   connector: 'TRS FEMALE' },
    { ch: '12', signal: 'Aku kyt',              output: 'AD4',   connector: 'TRS FEMALE' },
    { ch: '13', signal: 'Drums L + El.drums L', output: 'AD5',   connector: 'TRS FEMALE' },
    { ch: '14', signal: 'Drums R + El.drums R', output: 'AD6',   connector: 'TRS FEMALE' },
    { ch: '15', signal: 'Kytara L+Key L',       output: 'AD7',   connector: 'TRS FEMALE' },
    { ch: '16', signal: 'Kytara R+Key R',       output: 'AD8',   connector: 'TRS FEMALE' }
];

// Výchozí obsazení kapely. Použije se, dokud nejsou členové v tabulce
// web_members; záznamy z DB jej přebijí.
export const DEFAULT_MEMBERS = [
    { name: 'Míša Valentová', instrument: 'zpěv, saxofon' },
    { name: 'Matouš Hejduk',  instrument: 'zpěv, saxofony, akustická kytara' },
    { name: 'Josef Ryšávka',  instrument: 'trumpeta, zpěv' },
    { name: 'Michal Ryšávka', instrument: 'klávesy, elektrická kytara, zpěv' },
    { name: 'Jakub',          instrument: 'bicí nástroje' }
];
